import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { GrupoInterface } from "../../../Interfaces/Geral/Grupos/GrupoInterfaces";
import {
    ListarGruposController,
    DeletarGrupoController,
    AtualizarGrupoController,
} from "../../../Controllers/Geral/Grupos/GruposController";
import Table from "../../../Components/Table";
import { OverlayTrigger, Tooltip, Tab, Tabs } from "react-bootstrap";
import Swal from "sweetalert2";
import ModalEditarGrupo, { ModalEditarGrupoHeader } from "./ModalEditarGrupo";
import ModalCadastrarGrupo from "./ModalCadastrarGrupo";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import "./styles.css";

export default function Grupos() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const {
        execute: updateList,
        value: lstGrupos,
        loading: lstGruposLoading,
    } = useAsyncEffect(ListarGruposController);

    const gruposAtivos =
        lstGrupos && lstGrupos.filter((grupo) => grupo.FL_ATIVO);
    const gruposInativos =
        lstGrupos && lstGrupos.filter((grupo) => !grupo.FL_ATIVO);

    function RowTable(cell: any, row: GrupoInterface) {
        return (
            <>
                <div className="rowCapys">
                    <div>
                        <h4>{row.DS_GRUPO}</h4>
                        <div className="StatusGrupo">
                            {row.FL_ATIVO ? (
                                <span className="label abel-pill label-inline label-success mr-2">
                                    {" "}
                                    Ativado
                                </span>
                            ) : (
                                <span className="label label-danger abel-pill label-inline mr-2">
                                    Desativado
                                </span>
                            )}

                            {row.FL_ANALISAR_CREDITO ? (
                                <span className="label abel-pill label-inline label-success mr-2">
                                    {" "}
                                    Analisa de Credito
                                </span>
                            ) : null}

                            {row.FL_GERENCIAR_PRODUTOS ? (
                                <span className="label abel-pill label-inline label-success mr-2">
                                    {" "}
                                    Gerenciar Produtos
                                </span>
                            ) : null}
                        </div>
                    </div>
                    <div className="col-tools">
                        <div className="toolsTable">
                            <label className="text-white">Capys Tools</label>
                            <div className="tools-capys">
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {row.FL_ATIVO
                                                ? "Desativar Grupo"
                                                : "Ativar Grupo"}
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className="switch switch-outline switch-sm switch-icon switch-success"
                                        data-toggle="tooltip"
                                    >
                                        <label>
                                            <input
                                                id="FL_ATIVO_STATUS"
                                                name="fL_ATIVO"
                                                checked={row.FL_ATIVO}
                                                type="checkbox"
                                                onChange={() => {
                                                    row.FL_ATIVO =
                                                        !row.FL_ATIVO;
                                                    AtualizarGrupoController(
                                                        row
                                                    ).then((response) => {
                                                        //força o update da célula da tabela
                                                        row.DS_GRUPO += "-";
                                                        updateList();
                                                    });
                                                }}
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {row.FL_ANALISAR_CREDITO
                                                ? "Desativar Analise"
                                                : "Ativar Analise"}
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className="switch switch-outline switch-sm switch-icon switch-info"
                                        data-toggle="tooltip"
                                    >
                                        <label>
                                            <input
                                                id="fL_ANALISAR_CREDITO_STATUS"
                                                name="fL_ANALISAR_CREDITO"
                                                checked={
                                                    row.FL_ANALISAR_CREDITO
                                                }
                                                type="checkbox"
                                                onChange={() => {
                                                    row.FL_ANALISAR_CREDITO =
                                                        !row.FL_ANALISAR_CREDITO;
                                                    AtualizarGrupoController(
                                                        row
                                                    ).then((response) => {
                                                        row.DS_GRUPO += " ";
                                                        updateList();
                                                    });
                                                }}
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {row.FL_GERENCIAR_PRODUTOS
                                                ? "Desativar Gerencia de Produtos"
                                                : "Ativar Gerencia de Produtos"}
                                        </Tooltip>
                                    }
                                >
                                    <span className="switch switch-outline switch-sm switch-icon switch-warning">
                                        <label>
                                            <input
                                                id="fL_GERENCIAR_PRODUTOS_STATUS"
                                                name="fL_GERENCIAR_PRODUTOS"
                                                checked={
                                                    row.FL_GERENCIAR_PRODUTOS
                                                }
                                                type="checkbox"
                                                onChange={() => {
                                                    row.FL_GERENCIAR_PRODUTOS =
                                                        !row.FL_GERENCIAR_PRODUTOS;
                                                    AtualizarGrupoController(
                                                        row
                                                    ).then((response) => {
                                                        row.DS_GRUPO += " ";
                                                        updateList();
                                                    });
                                                }}
                                            />
                                            <span
                                                data-toggle="tooltip"
                                                data-theme="dark"
                                            ></span>
                                        </label>
                                    </span>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="Button-Tools">
                            <button
                                className="btn btn-outline-primary font-weight-bold mr-2"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () =>
                                            ModalEditarGrupo({
                                                iDGrupo: row.ID_GRUPO,
                                                updateList,
                                            }),
                                        customHeader: ModalEditarGrupoHeader(
                                            row.DS_GRUPO
                                        ),
                                        size: "xl",
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} size="lg" />{" "}
                                Editar
                            </button>
                            <button
                                className="btn btn-outline-danger font-weight-bold mr-2"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar este grupo?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        /* Read more about isConfirmed, isDenied below */
                                        if (result.isConfirmed) {
                                            DeletarGrupoController(
                                                row.ID_GRUPO
                                            ).then((response) => {
                                                updateList();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />{" "}
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const ColunsUser = [
        {
            dataField: "DS_GRUPO",
            text: "Descrição",
            formatter: RowTable,
            sort: true,
        },
    ];

    return (
        <div className="card card-custom" id="kt_page_sticky_card">
            <div className="card-header border-0 pt-5">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label font-weight-bolder text-dark gruposTitle">
                        Gestão de Grupos
                    </span>
                </h3>
                <div className="card-toolbar">
                    <button
                        className="btn btn-success font-weight-bold mr-2"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                Component: () =>
                                    ModalCadastrarGrupo({
                                        updateList,
                                        setShow,
                                    }),
                                noFooter: true,
                                noHeader: true,
                            });
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faPlus}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Novo Grupo
                    </button>
                </div>
            </div>
            <div className="card-body pt-2 pb-0 mt-n3">
                <Tabs defaultActiveKey="active" id="uncontrolled-tab-example">
                    <Tab eventKey="active" title="Ativos">
                        <div className="table-responsive-sm">
                            <Table
                                keyField="ID_GRUPO"
                                data={gruposAtivos || []}
                                loading={lstGruposLoading}
                                columns={ColunsUser}
                            />
                        </div>
                    </Tab>
                    <Tab eventKey="inactive" title="Inativos">
                        <div className="table-responsive-sm">
                            <Table
                                keyField="ID_GRUPO"
                                data={gruposInativos || []}
                                loading={lstGruposLoading}
                                columns={ColunsUser}
                            />
                        </div>
                    </Tab>
                </Tabs>
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
